// store/authSlice.js
import { USER_ROLE } from "@/utils/enum";
import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    isAuthenticated: false,
    userRole: USER_ROLE.USER,
  },
  reducers: {
    login: (state) => {
      state.isAuthenticated = true;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.userRole = USER_ROLE.USER;
    },
    setUserRole: (state, action) => {
      state.userRole = action.payload; // Update the userRole from the payload
    },
  },
});

export const { login, logout, setUserRole } = authSlice.actions;
export default authSlice.reducer;
